import {useContext} from 'react';

import ReportContext from '../../contexts/ReportContext';

const useReport = () => {
  return useContext(ReportContext);
};

export default useReport;
